import { render, staticRenderFns } from "./moreOU.vue?vue&type=template&id=24595222&lang=pug&"
import script from "./moreOU.vue?vue&type=script&lang=js&"
export * from "./moreOU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports